/**
 * Credit Event Payload Schemas
 *
 * Zod schemas for credit-related Socket.io event payloads.
 */

import { z } from 'zod';

// =============================================================================
// Credit Event Payload Schemas
// =============================================================================

export const CreditUpdatePayloadSchema = z.object({
  balance: z.number().nullable(),
  deduction: z.number(),
  taskId: z.string().optional(),
  reason: z.string(),
  taskCost: z.number().optional(),
  costCategory: z.enum(['intelligence', 'actions', 'compute', 'background']).optional(),
  ledgerId: z.string().optional(),
  ledgerAmount: z.number().optional(),
});

export const CreditWarningPayloadSchema = z.object({
  balance: z.number(),
  severity: z.enum(['low', 'critical', 'grace']),
  message: z.string(),
  graceExpiresAt: z.string().optional(),
});

export const CreditExhaustedPayloadSchema = z.object({
  balance: z.number(),
  message: z.string(),
});

export const CreditSyncPayloadSchema = z.object({
  balance: z.number(),
  isExhausted: z.boolean(),
  isGracePeriod: z.boolean(),
  expensiveTools: z.array(z.string()).optional(),
});

export const CreditToolCheckPayloadSchema = z.object({
  taskId: z.string().min(1),
  requestId: z.string().min(1),
  toolName: z.string(),
});

export const CreditToolVerdictPayloadSchema = z.object({
  requestId: z.string().min(1),
  approved: z.boolean(),
  denyReason: z.string().optional(),
});

export const CreditApprovalNeededPayloadSchema = z.object({
  taskId: z.string().min(1),
  requestId: z.string().min(1),
  toolName: z.string(),
  displayName: z.string(),
  estimatedCost: z.number(),
  currentBalance: z.number(),
});
